export const SIDEBAR_TEST_ID = 'sidebar';
export const CLOSE_SIDEBAR_TEST_ID = 'close-sidebar';
